'use strict';

/**
 * @classname LeafletMap
 * @classdesc Leaflet Map
 */
export default class LeafletMap {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('LeafletMap.constructor');
		this._$e = $e;
		this._id = $e.attr('id');
		this._lat = parseFloat($e.attr('data-lat'));
		this._lng = parseFloat($e.attr('data-lng'));
		this._zoom = parseInt($e.attr('data-zoom'));
		this._name = $e.attr('data-name');
		this._id = $e.attr('id');
		setTimeout(() => {
			this.init();
		}, 300);
	};


	/**
	 * 初期化
	 *
	 * @memberof LeafletMap
	 * @return {undefined}
	 */
	init() {
		console.log('LeafletMap.init');
		//console.log(`id: ${this._id} / lat: ${this._lat} / lng ${this._lng} / zoom: ${this._zoom}`);
		this._map = L.map(this._id).setView([this._lat, this._lng], this._zoom);
		const tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{
			attribution: '© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
			maxZoom: 19
		});
		/*
		const tileLayer = L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}.png', {
			maxZoom: 19,
			attribution: 'Map tiles by <a href="http://stamen.com" rel="nofollow noopener" target="_blank">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0" rel="nofollow noopener" target="_blank">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org" rel="nofollow noopener" target="_blank">OpenStreetMap</a>, under <a href="http://creativecommons.org/licenses/by-sa/3.0" rel="nofollow noopener" target="_blank">CC BY SA</a>.',
		});*/
		tileLayer.addTo(this._map);

		const marker = L.marker([this._lat, this._lng]).addTo(this._map);
		marker.bindPopup(this._name).openPopup();
	};
};